import { useTranslation, Trans } from "react-i18next";

import e1 from '../../img/InvestmentPlans/e1.svg'
import e2 from '../../img/InvestmentPlans/e2.svg'
import e3 from '../../img/InvestmentPlans/e3.svg'
import e4 from '../../img/InvestmentPlans/e4.svg'

function Execute() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="max-w-[1220px] flex flex-col">
                <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[497px] leading-[1.2]">{t('investment.10')}</p>
                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[20px] xl:max-w-[497px]">{t('investment.11')}</p>
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[40px]">
                    <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                        <img src={e1} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <div>
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.12')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('investment.13')}</p>
                        </div>
                    </div>
                    <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                        <img src={e2} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <div>
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.14')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('investment.15')}</p>
                        </div>
                    </div>
                    <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                        <img src={e3} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <div>
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.16')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('investment.17')}</p>
                        </div>
                    </div>
                    <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                        <img src={e4} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <div>
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.18')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('investment.19')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Execute;
 